import { Link } from "react-router-dom";

export interface BreadcrumbItem {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
  variant?: "default" | "light";
}

export default function Breadcrumb({ items, variant = "default" }: BreadcrumbProps) {
  const base = variant === "light" ? "text-background-200" : "text-foreground-500";
  const link = variant === "light" ? "hover:text-background-50" : "hover:text-primary-600";
  const current = variant === "light" ? "text-background-50" : "text-foreground-800";
  const arrow = variant === "light" ? "text-background-50/50" : "text-foreground-300";

  return (
    <nav aria-label="面包屑导航" className={`flex flex-wrap items-center gap-1.5 text-sm ${base}`}>
      <Link to="/" className={`flex items-center gap-1 transition-colors cursor-pointer ${link}`}>
        <i className="ri-home-4-line text-base" />
        首页
      </Link>
      {items.map((item) => (
        <span key={item.label} className="flex items-center gap-1.5">
          <i className={`ri-arrow-right-s-line text-base ${arrow}`} />
          {item.to ? (
            <Link to={item.to} className={`transition-colors cursor-pointer ${link}`}>
              {item.label}
            </Link>
          ) : (
            <span className={`font-medium ${current}`}>{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}